'use strict';

/* eslint-disable no-undef */

$(document).on("sfvto:init", function() {
    $.spinner().start();

    var event = new Event('YMKloaded');

    window.YMK.addEventListener('loaded', function () {
        setTimeout(
            function () {
                document.dispatchEvent(event);
            },
            1000
        );
    });

    var initParameters = {
        userConsent: 'agree',
        enableFourWayLooks: false,
        language: PropertiesPreferences.VTO_DATA_LANG
    };

    var windowSize = $(window).width();
    var windowHeight = $(window).height();
    var useMobileView = $(window).outerWidth() < 500;
    
    if (useMobileView) {
        initParameters.width = windowSize;
        initParameters.height = 476;
        if ($('.shade-finder-vto-body').find('.vto-revamp').length) {
            initParameters.height = windowHeight - ($('header').height());
            $('#vto-sf-modal').css('top', $('header').height() + 'px');
        }
    } else {
        initParameters.width = 547;
        initParameters.height = 619;
        if ($('.shade-finder-vto-body').find('.vto-revamp').length) {
            initParameters.width = 510;
            initParameters.height = 656;
        }
    }
    // Init VTO module
    window.YMK.init(initParameters);
    // Open VTO module
    window.YMK.open();

    window.YMK.addEventListener('backToLive', function () {
        $('.custom-shade-search').show();
        if (useMobileView) {
            $('.pdp-title-mobile').show();
        }
    });

    window.YMK.addEventListener('enterTakePhoto', function () {
        $('.custom-shade-search').hide();
        if (useMobileView) {
            $('.pdp-title-mobile').hide();
        }
    }); 

    window.YMK.addEventListener("closed", function() {
        $('#one-to-one-initiation').removeClass('d-none');
        $('#vto-sf-modal').modal('hide');
        $('.custom-shade-search').hide();
        $('.pdp-title-mobile').hide();
    });

    var $owltryon = $('.tryon-pdp');

    document.addEventListener('YMKloaded', function () {
        var currentShadeId = $(".shade-selector-button.selected").attr("data-attr-value");
        var isShadeFound = false;

        $owltryon.find('.owl-item').each(function () {
            var self = $(this);
            
            if (self.find('.is-outStock').length) {
                self.append('<span class="strock-line"></span>');
            }
        })

        adaptSuggestionShadeVTO();

        $('.tryon-pdp .shadefinder-shadesquare').each(function() {
            var $this = $(this);
            if ($this.attr("data-shade-id") === currentShadeId && currentShadeId !== undefined) {
                $(".custom-shade-search").removeClass("hidden");
                $('.pdp-title-mobile').removeClass('hidden');
                $this.trigger('click');
                window.YMK.applyMakeupBySku($this.attr('data-id'));
                if($this.length > 0) {
                    $owltryon.trigger('to.owl.carousel', $this.data('position'));
                }
                isShadeFound = true;
                return false;
            }
        })

        if (!isShadeFound) {
            var selectedFirstElement = $(".tryon-pdp .shadefinder-shadesquare").first();

            $(".custom-shade-search").removeClass("hidden");
            $('.pdp-title-mobile').removeClass('hidden');
            selectedFirstElement.trigger('click');
            window.YMK.applyMakeupBySku(selectedFirstElement.attr('data-id'));
        }
    });

    function onDraggedFunction(event) {
        var childrens = $(event.target).find('.shadefinder-shadesquare');
        var selectedValue = event.item.index;
        childrens.each( function(){
            if(parseInt($(this).attr('data-position')) === selectedValue){
                $(this).trigger('click');
            }
        })
    }

    function adaptSuggestionShadeVTO() {
        if ($('.shade-finder-vto-body').find('.vto-revamp').length) {
            var timeOut = 1000; 

            if (useMobileView) {
                setTimeout(
                    function () {
                        $('.suggestions-shade-vto').css({
                            'height' : (windowHeight - ($('header').height())) + 'px',
                            'width' : windowSize + 'px',
                            'top' : $('header').height() + 'px'
                        });
                    },
                    timeOut
                );
            } else {
                setTimeout(
                    function () {
                        $('.suggestions-shade-vto').css({
                            'height' : '660px',
                            'width' : '520px'
                        });
                    },
                    timeOut
                );
            }
        }
    }
    
    var $owltryonpdp = $('.tryon-pdp');
    var loopsParam = false;
    var centerMode = false;
    var maxDisplayShadeSquare = PropertiesPreferences.MAXIMUM_SHADE_SQUARE;
    
    $owltryonpdp.each( function() {
        $(this).children().each( function( index ) {
            $(this).attr( 'data-position', index );
        });
    });

    if ($owltryonpdp.find('.shadefinder-shadesquare').length > maxDisplayShadeSquare) {
        loopsParam = true;
        centerMode = true;
    }
    
    if ($('.shade-finder-vto-body').find('.vto-revamp').length) {
        $owltryonpdp.owlCarousel({
            loop: loopsParam,
            rewind: false,
            center: centerMode,
            margin: 10,
            nav: true,
            dots: false,
            transitionStyle: "fade",
            itemElement: "li",
            stageElement: "ul",
            autoWidth: true,
            onDragged: onDraggedFunction,
            items: 5,
            navText: [
                '<span class="icon-chevron-thin-right" aria-hidden="true"></span><span class="sr-only">Previous panel</span>',
                '<span class="icon-chevron-thin-right" aria-hidden="true"></span><span class="sr-only">Next panel</span>'
            ]
        });
    } else {
        $owltryonpdp.owlCarousel({
            loop: false,
            rewind: false,
            center: false,
            margin: 10,
            nav: true,
            dots: false,
            transitionStyle: "fade",
            itemElement: "li",
            stageElement: "ul",
            autoWidth: true,
            onDragged: onDraggedFunction,
            items: 5,
            navText: [
                '<span class="icon-chevron-thin-right" aria-hidden="true"></span><span class="sr-only">Previous panel</span>',
                '<span class="icon-chevron-thin-right" aria-hidden="true"></span><span class="sr-only">Next panel</span>'
            ]
        });
    }
    
    $(document).on('click', '.owl-item>svg', function() {
        $owltryonpdp.trigger('to.owl.carousel', $(this).data( 'position' ) );
        $(this).parent('.owl-item').addClass('focused').siblings('.owl-item').removeClass('focused');
        adaptSuggestionShadeVTO();
    });
    
    $(document).on('click', '.owl-prev, .owl-next', function() {
        var actualposition = $('.owl-item.focused .shadefinder-shadesquare').attr('data-position');
        $('.shadefinder-shadesquare').each(function(){
            if(parseInt($(this).attr('data-position')) === parseInt(actualposition)){
                $(this).trigger('click');
            }
        });
    });

    $.spinner().stop();

    function uploadPicture(input) {
        if (input.files && input.files[0]) {
            $(".VTOcamera-iconcontainer").removeClass('active');
            $('#YMK-wrapper .VTOpicture-iconcontainer').hide();
    
            var reader = new FileReader();
            reader.readAsDataURL(input.files[0]); // convert to base64 string
    
            reader.onload = function (e) {
                window.YMK.open( false , e.target.result); // reload module with upload image
            }
        }
    }
    
    function reloadmodule() {
        $(".VTOcamera-iconcontainer").addClass('active');
        $('#YMK-wrapper .VTOcamera-iconcontainer').hide();
        $('#YMK-wrapper .VTOpicture-iconcontainer').hide();
        window.YMK.open();
        $("#VTOpicture").val('');
    }
    
    $("#VTOpicture").change(function () {
        uploadPicture(this);
    });
    
    $(".VTOcamera-iconcontainer").click(function () {
        reloadmodule();
    });
});